var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"errorModal",attrs:{"id":"errorModal"}},[_c('b-modal',{attrs:{"title":"Error"},on:{"ok":_vm.closeModal,"cancel":_vm.closeModal},model:{value:(_vm.errorModalShow),callback:function ($$v) {_vm.errorModalShow=$$v},expression:"errorModalShow"}},[_c('span',[_vm._v(_vm._s(_vm.text))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12a5df9c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErrorModal.vue
// module id = null
// module chunks = 